<template>
  <div class="article-page">
    <HeadNav selectedLanguage="en" page="about" />
    <main class="article-container">
      <h1>{{ title }}</h1>
      <figure v-if="image" class="article-cover">
        <img :src="image" :alt="`${title} cover image`" />
      </figure>
      <slot />
    </main>
  </div>
</template>

<script>
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'ArticleLayout',
  components: {
    HeadNav
  },
  props: {
    title: {
      type: String,
      required: true
    },
    image: {
      type: String,
      default: ''
    }
  }
};
</script>

<style>
.article-page {
  min-height: 100vh;
  background: #f7f8fc;
  padding-bottom: 40px;
}

.article-page .article-container {
  max-width: 920px;
  margin: 40px auto 70px;
  padding: 48px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 12px 40px rgba(28, 37, 65, 0.08);
  color: #3f4756;
  font-size: 17px;
  line-height: 1.8;
}

.article-page .article-container h1 {
  margin: 0 0 28px;
  color: #182033;
  font-size: 2.35rem;
  line-height: 1.25;
}

.article-page .article-cover {
  margin: 0 0 34px;
  overflow: hidden;
  border-radius: 12px;
  background: #eef1f7;
}

.article-page .article-cover img {
  display: block;
  width: 100%;
  height: auto;
  aspect-ratio: 16 / 9;
  object-fit: cover;
}

.article-page .article-container h2 {
  margin: 42px 0 16px;
  color: #1f2937;
  font-size: 1.6rem;
  line-height: 1.35;
}

.article-page .article-container h3 {
  margin: 28px 0 12px;
  color: #263247;
  font-size: 1.22rem;
  line-height: 1.4;
}

.article-page .article-container p {
  margin: 0 0 18px;
}

.article-page .article-container ul,
.article-page .article-container ol {
  margin: 14px 0 20px;
  padding-left: 26px;
}

.article-page .article-container li {
  margin-bottom: 9px;
}

.article-page .article-container a {
  color: #2563eb;
  text-decoration: none;
}

.article-page .article-container a:hover {
  text-decoration: underline;
}

.article-page .lead {
  color: #4b5563;
  font-size: 1.08rem;
}

@media (max-width: 768px) {
  .article-page .article-container {
    margin: 20px 12px 40px;
    padding: 28px 20px;
    border-radius: 12px;
    font-size: 16px;
  }

  .article-page .article-container h1 {
    font-size: 1.82rem;
  }

  .article-page .article-cover {
    margin-bottom: 24px;
    border-radius: 8px;
  }

  .article-page .article-container h2 {
    font-size: 1.4rem;
  }

  .article-page .article-container h3 {
    font-size: 1.13rem;
  }
}
</style>
